import { render, staticRenderFns } from "./InputVoyage.vue?vue&type=template&id=cec20970"
import script from "./InputVoyage.vue?vue&type=script&lang=js"
export * from "./InputVoyage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports